import { Eyebrow, MaskedLines, Reveal } from "../motion/Reveal";
import { brand } from "../../content/site";

const pillars = [
  ["Field", "Engineers and logistics on the ground across sites."],
  ["Infrastructure", "Networks, wireless, AV and security systems."],
  ["Intelligence", "Software, AI and automation that create leverage."],
];

export const Intro = () => (
  <section id="about" data-testid="intro-section" className="tc-sheet bg-[#FAFAF9] py-24 text-stone-900 sm:py-32">
    <div className="mx-auto grid max-w-[1440px] gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-7">
        <Eyebrow light>01 — Introduction</Eyebrow>
        <h2 className="mt-8 font-display text-3xl font-medium leading-[1.08] tracking-tight sm:text-5xl lg:text-[3.6rem]">
          <MaskedLines inView stagger={0.1} lines={["A Kenyan technology", "company built on a", <span key="c" className="text-orange-700">simple idea — care.</span>]} />
        </h2>
        <Reveal delay={0.15}>
          <p className="mt-10 max-w-2xl text-base leading-relaxed text-stone-700 sm:text-lg">
            TechCare Technologies brings together field engineering, digital infrastructure, software and artificial
            intelligence under one roof. We help organisations plan, deploy and look after the technology they rely on —
            starting in Kenya, with an ambition to serve the wider African continent and, in time, international markets.
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <p className="mt-8 border-l-2 border-orange-600 pl-5 font-display text-lg text-stone-900 sm:text-xl">{brand.promise}</p>
        </Reveal>
      </div>
      <div className="lg:col-span-5">
        <Reveal className="relative">
          <div className="tc-frame relative aspect-[4/5] overflow-hidden rounded-[24px] bg-stone-200">
            <img src="/images/engineer-rack.jpg" alt="Engineer organising network cables in a server rack" loading="lazy"
              className="h-full w-full object-cover grayscale-[35%] transition-[filter,transform] duration-700 hover:scale-[1.03] hover:grayscale-0" />
            <div className="absolute inset-0 bg-gradient-to-t from-stone-950/60 via-transparent to-transparent" />
            <p className="absolute bottom-5 left-5 font-mono text-[10px] uppercase tracking-[0.25em] text-stone-100">Where Innovation Meets Care.</p>
          </div>
        </Reveal>
      </div>
      <div className="grid gap-px overflow-hidden rounded-2xl border border-stone-300 bg-stone-300 sm:grid-cols-3 lg:col-span-12">
        {pillars.map(([t, d], i) => (
          <Reveal key={t} delay={i * 0.08} className="bg-[#FAFAF9] p-7 sm:p-6 lg:p-9">
            <p className="font-mono text-xs text-orange-700">0{i + 1}</p>
            <p className="mt-6 font-display text-2xl sm:text-lg lg:text-2xl">{t}</p>
            <p className="mt-2 text-sm leading-relaxed text-stone-600">{d}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
